import type { DeleteEntityMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * Maps TRPC mutation response to match the GraphQL mutation structure.
 */
const mapTrpcResponseToGraphQL = (): DeleteEntityMutation => {
  return {
    deleteChildEntity: {
      __typename: 'GenericMutationOutput',
      affected_rows: 1,
    },
  };
};

export const useDeleteEntityTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.entity.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.entity.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.entity.getById.queryKey(),
        });
      },
    }),
  });

  return {
    deleteEntity: async (variables: {
      Id: string;
    }): Promise<DeleteEntityMutation> => {
      await mutation.mutateAsync({ Id: variables.Id });

      return mapTrpcResponseToGraphQL();
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
